import { memo, useEffect } from "react"
import { useFetchTableQrCodeImageUrl } from "../../../hooks/menu/useFetchTableQrCodeImageUrl";
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { getQrCodeUrl } from "../../../utils/getQrCodeUrl";

type MobileOrderQrProps = {
  tableId: string;
}
export const NoUseLineMobileOrderQr: React.FC<MobileOrderQrProps> = memo(({tableId}) => {
  const { qrCodeImageUrl } = useFetchTableQrCodeImageUrl(tableId);
  useEffect(() => {
    if (!qrCodeImageUrl) return;
    const navigateToQrCodeUrl = async () => {
      const qrCodeUrl = await getQrCodeUrl(qrCodeImageUrl);
      window.location.href = qrCodeUrl;
    };
    navigateToQrCodeUrl();
  }, [qrCodeImageUrl]);
  return (
    <CircularLoading/>
  );
});